import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceCalibrationSummary } from 'src/app/_models/device-calibration-summary';
import { Module } from 'src/app/_models/module-enum';

@Component({
    selector: 'app-dynamic-dropdown-form-field',
    templateUrl: './dynamic-dropdown-form-field.component.html',
    styleUrls: ['./dynamic-dropdown-form-field.component.scss'],
    imports: [FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicDropdownFormFieldComponent {
  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** The device being referenced by this dropdown (required) */
  device = input<DeviceCalibrationSummary>();

  /** Should the select be disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Placeholder text shown as the default option (required) */
  placeholder = input<string>();

  /**Enum denoting which calibration type the dropdown renders (required) */
  calibrationType = input<Module>(Module.BaseModule);

  /** Gets the current value of the form control that corresponds to the select */
  public get value(): string | null {
    const dev = this.device();
    const form = this.parentForm();
    if (!dev || !form) return null;
    const controlName = `device_${dev.deviceId.toString()}`;
    return (form.controls[controlName]?.value as string) ?? null;
  }
}
